import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store, createSelector } from '@ngrx/store';

import { selectPinnedJobs, selectRecentJobs } from '../../base/menu/quick-access/quick-access-reducers';
import { FreyaCommonModule } from '../../freya-common/freya-common.module';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-recent-jobs-card',
  standalone: true,
  imports: [CommonModule, RouterLink, FreyaCommonModule, SharedModule],
  template: `
    <ng-container *ngIf="viewModel$ | async as vm">
      <div class="recent-jobs-content">
        <ng-container *ngIf="vm.pinnedJobs.length">
          <h5 class="section-title">Pinned</h5>
          <a
            *ngFor="let job of vm.pinnedJobs"
            class="job-item"
            [routerLink]="job.jobLink"
            [queryParams]="{ zone: job.contextZone }"
          >
            <i class="pi pi-bookmark"></i>
            <div class="job-info">
              <span class="job-name">{{ job?.users | jobCustomer }}</span>
              <span class="job-details">{{ job.stage | titlecase }} | {{ job.code }}</span>
            </div>
          </a>
        </ng-container>

        <ng-container *ngIf="vm.recentJobs.length">
          <h5 class="section-title" *ngIf="vm.pinnedJobs.length">Recent</h5>
          <a
            *ngFor="let job of vm.recentJobs"
            class="job-item"
            [routerLink]="job.jobLink"
            [queryParams]="{ zone: job.contextZone }"
          >
            <i class="pi pi-clock"></i>
            <div class="job-info">
              <span class="job-name">{{ job?.users | jobCustomer }}</span>
              <span class="job-details">{{ job.stage | titlecase }} | {{ job.code }}</span>
            </div>
          </a>
        </ng-container>

        <div *ngIf="vm.isEmpty" class="empty-state">
          No recent jobs. Open a job to get started!
        </div>
      </div>
    </ng-container>
  `,
  styles: [`
    .recent-jobs-content {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .section-title {
      margin: 0 0 0.25rem 0;
      font-size: 0.8rem;
      font-weight: 600;
      color: var(--text-color-secondary);
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
    .job-item {
      display: flex;
      align-items: center;
      gap: 0.625rem;
      padding: 0.5rem 0.75rem;
      border-radius: 6px;
      text-decoration: none;
      color: var(--text-color);
      transition: background 0.15s;
    }
    .job-item:hover {
      background: var(--surface-hover);
    }
    .job-item > i {
      font-size: 0.875rem;
      color: var(--text-color-secondary);
      width: 1rem;
      text-align: center;
    }
    .job-info {
      display: flex;
      flex-direction: column;
      gap: 2px;
      overflow: hidden;
    }
    .job-name {
      font-size: 0.875rem;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .job-details {
      font-size: 0.75rem;
      color: var(--text-color-secondary);
    }
    .empty-state {
      color: var(--text-color-secondary);
      font-size: 0.875rem;
      padding: 0.5rem 0;
    }
  `],
})
export class RecentJobsCardComponent {
  viewModel$ = this.store.select(createSelector({
    pinnedJobs: selectPinnedJobs,
    recentJobs: selectRecentJobs,
    isEmpty: createSelector(
      selectPinnedJobs,
      selectRecentJobs,
      (pinned, recent) => pinned.length + recent.length === 0,
    ),
  }));

  constructor(public store: Store) {}
}